import React, { useState } from 'react';
import CloseIcon from "../../../../../src/assets/images/icons/close_icon.svg";
import LangIcon from "../../../../../src/assets/images/all/lang_icon.png";
// import EnglandFlag from "../../../../../src/assets/images/all/language.svg";
// import IndonesiaFlag from "../../../../../src/assets/images/all/twemoji_flag-indonesia.svg";
import { makeAjax, respStatus, showMessage, url } from '../../../../helpers/global_helper';
import EnglandFlag from "../../../../../src/assets/images/all/Eng_flag.png";
import IndonesiaFlag from "../../../../../src/assets/images/all/Ind_flag.png";
import i18next from 'i18next';
import { withTranslation } from "react-i18next";

const Language = (props) => {
  const { onClose, onLanguageChange } = props;
  const defaultLanguage = localStorage.getItem("I18N_LANGUAGE") || 'id';
  const [selectedLanguage, setSelectedLanguage] = useState(defaultLanguage);
  const updateUserLanguage = (lang) => {
    let reqData = {
      lang: lang
    };

    makeAjax(
      url.PLAYER_API.updateUserLanguage, reqData, url.PLAYER_MS_EXT).then(response => {
        if (response.status !== respStatus['SUCCESS']) {
          showMessage(response);
          return;
        }
        localStorage.setItem("I18N_LANGUAGE", lang);
        i18next.changeLanguage(lang);
        setSelectedLanguage(lang);
        onLanguageChange(lang);
      });
  }
  return (
    <>
      <div className='lang_dp_main'>
        <div className='lang_dp_overlay' onClick={onClose}></div>
        <div className="lang_dp_container">

          {/* <img src={LangIcon} alt='' />
           <p>{(props.t("language"))}</p>  
                    */}
          <img src={CloseIcon} className='lang_close_icon' alt='' onClick={onClose} />
          <div className='lang_dp_row' >
            <img src={LangIcon} alt='' />
            <p>{(props.t("language"))}</p>

          </div>


          {selectedLanguage !== 'id' && (
            <div className='lang_dp_row' onClick={() => { updateUserLanguage('id') }}>
              <img src={IndonesiaFlag} alt='' />
              <p>Indonesia</p>
            </div>
          )}
          {selectedLanguage !== 'en' && (
            <div className='lang_dp_row' onClick={() => { updateUserLanguage('en') }}>
              <img src={EnglandFlag} alt='' />
              <p>English</p>
            </div>
          )}
        </div>
      </div>
    </>

  )
}

export default withTranslation()(Language)
